export default {
  title: "محصولات دست دوم",
  content: "توضیحات صفحه",
  about: "متن درباره",
  faqList: "سوالات پرتکرار",
};
